import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=51f05510&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=51f05510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f05510",
  null
  
)

export default component.exports